const breakpoints = {
  xs: 320,
  mobile: 400,
  mobileMax: 460,
  sm: 640,
  md: 1024,
  lg: 1400,
  xl: 1600,
};

export default breakpoints;
